import { Component, OnInit } from '@angular/core';
import { CommentClass } from '../../../class/commentclass'
import { DropDownClass } from '../../../class/dropdownclass'
import { CommentService } from '../../../api/comment.service'
import { HelperService,ErrorClass } from '../../../api/helper.service'

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {


  constructor(
    private commentAPI:CommentService,
    private help:HelperService,
  ) { }

  public commentList:CommentClass[]= []
  public statusList:DropDownClass[] = []

  showEdit = false;

  ngOnInit() {
     this.loadComments()
  }

  loadComments(){
    this.commentAPI.getComment().subscribe(
      (data:CommentClass[]) => {
         this.commentList = data.map(
           (val:CommentClass) => {
              val.show_edit = false
              val.update_status = 2
              return val
           }
         )
         this.loadCommentStatus()
      },
      (err:ErrorClass) => {
        this.help.msgboxError('Error', err.error_message)
      }
    )
  }

  loadCommentStatus(){
     this.commentAPI.getCommentStatus().subscribe(
       (data:DropDownClass[]) => {
         this.statusList = data.map(
           (val:DropDownClass) => {
             if(val.id == 2){
               val.is_selected = "selected"
             }
             return val
           }
         )
       },
      (err:ErrorClass) => {
        this.help.msgboxError('Error', err.error_message)
      }
     )
  }

  updateComment(id,status){  
    const body = {
      fundraiser_comment_id: id,
      status_id:status
    }

    this.commentAPI.updateComment(body).subscribe(
      (data) => {
          this.help.msgbox("Success",'Comment Status has been updated')
          this.loadComments()
      },
     (err:ErrorClass) => {
       this.help.msgboxError('Error', err.error_message)
     })
  }

  

}
